<template>
  <div
    class="redio-single-choice"
    :class="{
      'redio-single-choice-small' : size === 'small',
      'vertical': selectedShowStyle === 2
    }"
  >
    <el-radio
      v-on="$listeners"
      v-bind="{ ...$props }"
      v-for="item in options"
      :disabled="disabled"
      :key="item.choiceKey"
      v-model="value"
      :label="item.choiceKey"
      :title="item.value"
    >{{ item.value }}
      <slot name="radio-label"></slot>
    </el-radio
    >
  </div>
</template>

<script>
  import {singleChoiceProps} from '../index.js'

  export default {
    props: singleChoiceProps
  }
</script>

<style lang="scss" scoped>
.vertical{
  ::v-deep .el-radio{
    width: 100%;
    display: block;
    height: 32px;
    line-height: 32px;
  }
}
</style>
